module.exports = __webpack_public_path__ + "static/media/cyr_headSupport.20f4699a.jpg";